import {
  setApplicationId,
  setApplicationStatus,
  setCreditScoreResult,
  setCreditScoringRes,
  setFamilyInfo,
  setTimer,
  setWhitelistAddress
} from 'store/actions';

const handleFamilyAndAddress = (dispatch, param, body) => {
  if (param.familyInfo) {
    dispatch(setFamilyInfo(param.familyInfo));
  }

  if (param.whitelistAddress?.fullAddress && body.applicantInformation) {
    setWhitelistAddress(
      param.whitelistAddress.fullAddress,
      body.applicantInformation
    );
  }
};

const handleModeActions = (dispatch, param, data, action) => {
  const noExtraInfo =
    !param.personInfo && !param.occupationInfo && !param.familyInfo;

  const modeActions = {
    add: () => noExtraInfo && action?.push('/form-fill'),
    edit: () => noExtraInfo && action?.(prev => !prev),
    pause: () => dispatch(setApplicationId(data.applicationId)),
    submit: () => {
      if (data) {
        dispatch(setCreditScoringRes(data));
        dispatch(setApplicationId(data.applicationId));
        dispatch(
          setTimer({ minutes: data.timeLeftForScoreCompletion, seconds: 0 })
        );
        dispatch(setCreditScoreResult(''));
      }
    }
  };

  modeActions[param.mode]?.();
};

/**
 * to handle success response for put application
 * @param {*} dispatch
 * @param {*} res
 * @param {*} param
 * @param {*} body
 * @param {*} action
 */
export const handleSuccessResponsePutApplication = (
  dispatch,
  res,
  param,
  body,
  action
) => {
  const data = res.data.data;

  handleFamilyAndAddress(dispatch, param, body);

  handleModeActions(dispatch, param, data, action);

  // update application status
  data?.applicationStatus?.cmCode &&
    dispatch(setApplicationStatus(data.applicationStatus.cmCode));

  // run action if applicable
  if (param.occupationInfo || action) {
    action?.();
  }
};
